export default {
  namespaced: true,
  
  state: {
    messages: [],
    loading: false,
    error: null
  },
  
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_MESSAGES(state, messages) {
      state.messages = messages
    }
  },
  
  actions: {
    async fetchMessages({ commit }) {
      commit('SET_LOADING', true)
      try {
        // TODO: Implement chat API calls
        commit('SET_MESSAGES', [])
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  
  getters: {
    isLoading: state => state.loading,
    error: state => state.error,
    messages: state => state.messages
  }
} 